import React, { useEffect, useState } from "react";
import "../Assets/Css/home.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaBullseye, FaFlagCheckered } from "react-icons/fa";
import hexImg from "../Assets/Image/delta-hex.jpg";
import {
  FaClipboardCheck,
  FaDraftingCompass,
  FaCogs,
  FaTruck,
  FaIndustry,
  FaCheckCircle,
} from "react-icons/fa";
import { FaGlobe, FaCubes } from "react-icons/fa";
import { FaCertificate } from "react-icons/fa";
import { FaStar } from "react-icons/fa";
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import { Helmet } from "react-helmet";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useNavigate } from "react-router-dom";
import resistance from "../Assets/Image/resistance.jpg";
import copperLaminated from "../Assets/Image/copper-laminated.jpg";
import aluminumLaminated from "../Assets/Image/alumiumlaminated.jpg";
import fabricatedCopper from "../Assets/Image/fabricatedcopper.jpg";
import nonFerrousMachined from "../Assets/Image/nonferrousmachined01.jpg";
import subAssemblySwitchgear from "../Assets/Image/subassewitch01.jpg";
import subAssemblyBusbar from "../Assets/Image/subassebts.jpg";
import plugInAssemblies from "../Assets/Image/bts.jpg";
import fishPlates from "../Assets/Image/fish1.jpg";
import stampedNonFerrous from "../Assets/Image/stampedNonferrous1.jpg";
import ferrous from "../Assets/Image/ferrous.jpg";
import silverBrazing from "../Assets/Image/silver01.jpg";
import tinPlated from "../Assets/Image/tin.jpg";
import precismachined from "../Assets/Image/precismachined.jpeg";
import { Link } from "react-router-dom";
import copperFullTin from "../Assets/Image/copperFullTin.jpeg";
import busbarsubassembles from "../Assets/Image/busbarsubassembles .jpeg";
import leftaboutsection from "../Assets/Image/data-home-about.jpg";
import img1 from "../Assets/Image/machine1.jpg";
import img2 from "../Assets/Image/machine2.jpg";
import img3 from "../Assets/Image/machine3.jpg";
import img4 from "../Assets/Image/machine4.jpg";
import img5 from "../Assets/Image/machine5.jpg";
import banner1 from "../Assets//Image/banner1.jpg";
import banner2 from "../Assets/Image/banner2.jpg";

export default function HomePage() {
  const navigate = useNavigate();
  const [activeIdx, setActiveIdx] = useState(null);
  const handleTitleClick = (idx) =>
    setActiveIdx((prev) => (prev === idx ? null : idx));

  const handleClick = (index) => {
    setOpenStates((prev) => prev.map((val, i) => (i === index ? !val : val)));
  };
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  const products = [
    {
      name: "Braided Flexible",
      image: resistance,
      route: "/resistance-welded-flexibles",
    },
    {
      name: "Copper Laminated Flexibles",
      image: copperLaminated,
      route: "/copper-laminated-flexibles",
    },

    {
      name: "Aluminum Laminated Flexibles",
      image: aluminumLaminated,
      route: "/aluminum-laminated-flexibles",
    },
    {
      name: "Fabricated Copper Busbars",
      image: fabricatedCopper,
      route: "/fabricated-copper-busbars",
    },
    {
      name: "Non-Ferrous Machined Parts",
      image: nonFerrousMachined,
      route: "/non-ferrous-machined-parts",
    },
    {
      name: "Bimetallic Products and Washers",
      image: ferrous,
      route: "/bimetallic-products-and-washers",
    },
    {
      name: "Sub Assemblies - Switchgear",
      image: subAssemblySwitchgear,
      route: "/sub-assemblies-switchgear",
    },
    {
      name: "Sub Assemblies - Busbar Trunking",
      image: subAssemblyBusbar,
      route: "/sub-assemblies-busbar-trunking",
    },
    {
      name: "Busbar Trunking - Plug In Assemblies",
      image: plugInAssemblies,
      route: "/busbar-trunking-plug-in-assemblies",
    },
    {
      name: "Fish Plates for Busbar Trunking",
      image: fishPlates,
      route: "/fish-plates-for-busbar-trunking",
    },
    {
      name: "Stamped Parts - Non Ferrous",
      image: stampedNonFerrous,
      route: "/stamped-parts-non-ferrous",
    },
    {
      name: "Silver Brazing",
      image: silverBrazing,
      route: "/silver-brazing",
    },
    {
      name: "Tin/Silver Plated Copper Bars",
      image: tinPlated,
      route: "/tin-silver-plated-copper-bars",
    },

    {
      name: "Busbar Sub Assemblies",
      image: busbarsubassembles,
      // route: "/copper-laminated-flexibles"
    },
    {
      name: "Fully Tin Plated Copper Flexible",
      image: copperFullTin,
      // route: "/copper-lamination-full-tinned"
    },
    {
      name: "Precise Machined Copper Parts",
      image: precismachined,
      // route: "/fabricated-aluminum-busbars"
    },
  ];

  const productDetails = [
    {
      title: "Automated Foil Cutting Machine",
      short: "Precision cutting for copper foils",
      detail: "Ensures clean, consistent cuts for laminated connectors.",
      image: img1,
    },
    {
      title: "Resistance Welding Machine for Flexibles",
      short: "Robust welding for laminated flexibles",
      detail:
        "High-quality resistance welds ensuring uniform electrical conductivity.",
      image: img2,
    },
    {
      title: "Silver Brazing Machines",
      short: "Superior contact area joining",
      detail:
        "Uniform silver brazing with precise control for low contact resistance.",
      image: img3,
    },
    {
      title: "Vertical Milling Machines (VMC)",
      short: "Advanced vertical machining",
      detail: "Enables high-precision shaping of busbars and connectors.",
      image: img4,
    },
    {
      title: "Fabricated Busbar Processing Machine",
      short: "Complete busbar fabrication",
      detail: "Handles cutting, punching, and forming of busbars.",
      image: img5,
    },
  ];
  const [openStates, setOpenStates] = useState(productDetails.map(() => false));


  const approachPoints = [
    {
      title: "Custom Requirements",
      icon: <FaClipboardCheck size={40} className="approch-icon" />,
      description:
        "We work closely with you to understand every detail of your electrical connection needs, ensuring custom solutions that match your specifications exactly.",
    },
    {
      title: "Precision Design",
      icon: <FaDraftingCompass size={40} className="approch-icon" />,
      description:
        "Our team uses advanced CAD modeling and thorough technical reviews to ensure precision, accuracy, consistency, and reliable performance in every innovative design.",
    },
    {
      title: "Quality Manufacturing",
      icon: <FaCogs size={40} className="approch-icon" />,
      description:
        "ISO 9001:2015-certified production using advanced machinery and rigorous in-process quality checks delivers consistent, reliable results.",
    },
    {
      title: "On-Time Delivery",
      icon: <FaTruck size={40} className="approch-icon" />,
      description:
        "Carefully packed and delivered on schedule, ensuring your critical projects run smoothly, efficiently, and without unexpected delays or interruptions in workflow.",
    },
  ];

  const aboutPoints = [
    "We focus on: Quality Products, Timely Delivery, Competitive Pricing, and Customer Satisfaction.",
    "At Delta Engineering, we are dedicated to delivering reliable, high-quality, and customized electrical connection solutions designed for the power industry.",
    "We specialize in manufacturing laminated copper flexible connectors and fabricated busbars from both copper and aluminium, precisely engineered to meet customer-specific requirements.",
    "Our expertise also extends to supporting the Busbar Trunking System industry with Plug-in / Tap-off box assemblies, Joint packs, Spring hangers, and other essential accessories.",
    "From robust busbar trunking solutions to custom clamps, U-clips, and precision silver-brazed flexibles, every product reflects superior craftsmanship, durability, and consistent performance.",
    "Driven by innovation and quality, Delta Engineering continues to power industries with advanced solutions tailored to modern energy needs.",
  ];

  return (
    <>
      <Helmet>
        {/* 🔹 Page Title */}
        <title>Delta Engineering | Quality Flexible Manufacturer</title>
        {/* 🔹 Meta Description */}
        <meta
          name="description"
          content="Delta Engineering manufactures high-quality copper connectors, busbars, and custom electrical components for the power industry. Reliable, precision-crafted solutions."
        />
        {/* 🔹 Keywords */}
        <meta
          name="keywords"
          content="Delta Engineering, laminated flexible connectors, busbars, copper connectors, power industry, custom electrical solutions, resistance welding, VMC, silver brazing, plug-in box, joint packs, copper foil cutting"
        />
        {/* 🔹 Canonical URL */}
        <link rel="canonical" href="https://deltaengnsk.com/" />
        {/* 🔹 Open Graph for Social Sharing */}
        <meta property="og:title" content="Delta Engineering" />
        <meta
          property="og:description"
          content="We provide high-quality copper connectors, busbars, and precision-engineered components for the power industry."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://deltaengnsk.com/" />
        <meta
          property="og:image"
          content="https://deltaengnsk.com/your-logo.png"
        />{" "}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Delta Engineering" />
        <meta
          name="twitter:description"
          content="High-quality copper connectors and laminated busbars for power industries."
        />
        <meta
          name="twitter:image"
          content="https://deltaengnsk.com/your-logo.png"
        />
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
 <div className="banner1-section position-relative">
  <Swiper
    spaceBetween={0}
    centeredSlides={true}
    autoplay={{ delay: 3000, disableOnInteraction: false }}
    // pagination={{ clickable: true }}  
    modules={[Autoplay, Pagination]}   
    className="mySwiper w-100 custom-swiper-2"
  >
    <SwiperSlide>
      <img
        src={banner1}
        alt="Banner 1"
        className="img-fluid banner-slide-img"
      />
    </SwiperSlide>
    <SwiperSlide>
      <img
        src={banner2}
        alt="Banner 2"
        className="img-fluid banner-slide-img"
      />
    </SwiperSlide>
  </Swiper>

  <div className="banner1-overlay text-center">
    <div className="hero-content text-center">
      <h1
        className="hero-title fw-bold text-uppercase"
        data-aos="zoom-in"
        data-aos-delay="300"
      >
        DELTA <span>ENGINEERING</span>
      </h1>
      <h3 className="text-white hero-subtitle" data-aos="zoom-in"
        data-aos-delay="300">Components to Power Industries</h3>
    </div>
    <h3
      className="banner1-subtitle"
      data-aos="zoom-in"
      data-aos-delay="200"
    >
      We deliver tailored, high-performance electrical
      components that meet the unique demands of the power industry, ensuring
      reliability and excellence in every solution
    </h3>
    <Button
      variant="light"
      className="banner1-button mt-5"
      href="ourproducts"
      data-aos="zoom-in"
      data-aos-delay="300"
    >
      Our Products{" "}
      <IoArrowForwardCircleOutline
        size={30}
        style={{
          animation: "pulse 1.5s infinite",
          transformOrigin: "center",
        }}
      />
    </Button>
  </div>
</div>

      <section className="about-section py-4 bg-light pt-1">
        <Container>
          <Row className="text-center section-heading mb-5">
            <Col>
              <h3 className="fw-bold section-title position-relative d-inline-block">
                Delta Engineering
                <span className="title-underline"></span>
              </h3>
            </Col>
          </Row>
          <Row className="align-items-center">
            <Col
              xs={12}
              md={6}
              className="mb-4 mb-md-0"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <img
                src={leftaboutsection}
                alt="About Delta Engineering"
                className="img-fluid rounded shadow-lg border border-2"
                loading="lazy"
                style={{
                  maxHeight: "500px",
                  objectFit: "cover",
                }}
              />
            </Col>
            <Col xs={12} md={6} className="aboutmid text-center text-md-start">
              {aboutPoints.map((point, index) => (
                <p
                  key={index}
                  className="text-muted mb-3"
                  style={{ textAlign: "justify", fontSize: "1.05rem" }}
                  data-aos="fade-up"
                  data-aos-delay={300 + index * 150}
                >
                  {point}
                </p>
              ))}
            </Col>
          </Row>
        </Container>
      </section>

      <section className="py-5 bg-light">
        <Container>
          <Row
            className="g-4 align-items-stretch "
            style={{ minHeight: "450px" }}
          >
            <h3 className="fw-bold section-title position-relative d-inline-block">
              Company at a Glance
              <span className="title-underline"></span>
            </h3>
            <Col md={5}>
              <div
                className="h-100 p-4 d-flex flex-column justify-content-center text-white rounded"
                style={{
                  backgroundColor: "#6d5c28ff",
                  color: "#333",
                }}
              >
                <h3 className="fw-bold">
                  Leading Manufacturer, Exporter of Power Transmission,
                  Distribution and Metal Components Since 2017.
                </h3>
                <Button
                  variant="light"
                  className="mt-3 fw-bold"
                  onClick={() => navigate("/data")}
                >
                  Product Range
                </Button>
              </div>
            </Col>
            <Col md={7}>
              <Row className="g-4">
                <Col sm={6}>
                  <div className="bg-white shadow-sm rounded p-3 h-100 d-flex align-items-center gap-3">
                    <FaCubes size={50} className="text-dark" />
                    <div>
                      <h2 className="fw-bold mb-0" style={{ color: "#ff6600" }}>
                        50 +
                      </h2>
                      <h5 className="mb-0">Variety of Products </h5>
                    </div>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="bg-white shadow-sm rounded p-3 h-100 d-flex align-items-center gap-3">
                    <FaIndustry size={50} className="text-dark" />
                    <div>
                      <h2 className="fw-bold mb-0" style={{ color: "#ff6600" }}>
                        2017
                      </h2>
                      <h5 className="mb-0">Year of Establishment</h5>
                    </div>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="bg-white shadow-sm rounded p-3 h-100 d-flex align-items-center gap-3">
                    <FaCertificate size={50} className="text-dark" />
                    <div>
                      <h2 className="fw-bold mb-0" style={{ color: "#ff6600" }}>
                        9001:2015
                      </h2>
                      <h5 className="mb-0">Certified Company</h5>
                    </div>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="bg-white shadow-sm rounded p-3 h-100 d-flex align-items-center gap-3">
                    <FaGlobe size={50} className="text-dark" />
                    <div>
                      <h2 className="fw-bold mb-0" style={{ color: "#ff6600" }}>
                        30 +
                      </h2>
                      <h5 className="mb-0">Customers we Serve </h5>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
      <section
        className="vision-section py-5 text-light"
        style={{ backgroundColor: "#101010", color: "white" }}
      >
        <Container className="py-3">
          <Row className="align-items-center text-center justify-content-center">
            <h2
              className="fw-bold section-title2 position-relative d-inline-block"
              data-aos="fade-up"
            >
              Premium Electrical Components
              <span className="title-underline mb-4"></span>
            </h2>
            <Col md={6} className="text-center mb-4 mb-md-0" data-aos="zoom-in">
              <div className="hexagon-wrapper mx-auto">
                <div className="hexagon">
                  <img
                    src={hexImg}
                    alt="Delta Engineering Products"
                    className="img-fluid"
                  />
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-4" data-aos="fade-up" data-aos-delay="200">
                <h5
                  className="fw-bold d-flex align-items-center mb-2"
                  style={{ color: "#1f66fb" }}
                >
                  <FaBullseye className="me-2 text-danger" /> Our Vision
                </h5>
                <p className="text-start">
                  To be the most trusted manufacturer of power industry
                  components, delivering high-quality, tailored electrical
                  solutions that power the future with efficiency, innovation,
                  and reliability.
                </p>
              </div>
              <div className="mb-4" data-aos="fade-up" data-aos-delay="500">
                <h5
                  className="fw-bold d-flex align-items-center mb-2"
                  style={{ color: "#1f66fb" }}
                >
                  <FaFlagCheckered className="me-2 text-warning" /> Our Mission
                </h5>
                <p className="text-start">
                  We are committed to delivering reliable, high-performance
                  electrical components. Our team ensures superior craftsmanship
                  in products like switchgear panels, transformers, EV battery
                  parts, and more.
                </p>
              </div>
              <div data-aos="fade-up" data-aos-delay="800">
                <h5
                  className="fw-bold d-flex align-items-center mb-3"
                  style={{ color: "#1f66fb" }}
                >
                  <FaStar className="me-2 text-warning" /> Core Values
                </h5>
                <ul className="list-unstyled text-start">
                  <li className="mb-2 d-flex align-items-start">
                    <FaCheckCircle className="me-2 text-success mt-1" />
                    <span>
                      <strong>Excellence</strong> – Uncompromising quality and
                      performance
                    </span>
                  </li>
                  <li className="mb-2 d-flex align-items-start">
                    <FaCheckCircle className="me-2 text-success mt-1" />
                    <span>
                      <strong>Customer Focus</strong> – Tailored solutions
                      around your needs
                    </span>
                  </li>
                  <li className="mb-2 d-flex align-items-start">
                    <FaCheckCircle className="me-2 text-success mt-1" />
                    <span>
                      <strong>Innovation</strong> – Smarter, efficient,
                      tech-driven designs
                    </span>
                  </li>
                  <li className="mb-2 d-flex align-items-start">
                    <FaCheckCircle className="me-2 text-success mt-1" />
                    <span>
                      <strong>Integrity</strong> – Ethical, transparent
                      operations
                    </span>
                  </li>
                  <li className="d-flex align-items-start">
                    <FaCheckCircle className="me-2 text-success mt-1" />
                    <span>
                      <strong>Precision</strong> – Accurate engineering in every
                      product
                    </span>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="py-5 bg-light" id="our-products">
        <div className="container">
          <div className="text-center mb-5">
            <h3 className="fw-bold section-title position-relative d-inline-block">
              Products We Specialize In
            </h3>
            <p
              className="text-muted mx-auto"
              style={{ maxWidth: "700px" }}
              data-aos="fade-up"
              data-aos-delay="100"
            >
              We manufacture an extensive array of products like Copper
              Laminated Flexibles, Aluminium Flexibles, Copper and Aluminium
              Busbars, Copper and Aluminium Machined components , Brass
              Components , Earthing Components, Silver Brazed components , Non
              ferrous Stamped components.
            </p>
          </div>
          <Swiper
            modules={[Autoplay, Pagination, Navigation]}
            spaceBetween={20}
            slidesPerView={3}
            loop={true}
            centeredSlides={true}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            navigation
            //  pagination={{ clickable: true }}
            breakpoints={{
              320: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            className="custom-swiper"
          >
            {products.map((product, index) => (
              <SwiperSlide key={index}>
                <div className="product-slide text-center p-3 bg-white border rounded shadow-sm h-100 d-flex flex-column justify-content-between">
                  <div>
                    <img
                      src={product.image}
                      alt={product.name}
                      className="img-fluid mb-3"
                      style={{ height: "180px", objectFit: "contain" }}
                    />
                    <h5 className="fw-semibold">{product.name}</h5>
                  </div>
                  <div className="mt-3">
                    <Link to={product.route}>
                      <button className="btn btn-outline-primary btn-sm">
                        View More
                      </button>
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
      <section
        className="manufacturing-section py-5"
        style={{ overflow: "visible" }}
      >
        <Container>
          <div className="text-center mb-5">
            <h2
              className="fw-bold section-title text-primary position-relative d-inline-block "
              data-aos="fade-up"
            >
              Components to Power Industries
              <span className="title-underline"></span>
            </h2>

            <h3
              className="section-subtitle"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <strong> OUR MANUFACTURING PROCESS</strong>
            </h3>
          </div>
          <Row className="justify-content-center">
            {approachPoints.map(({ title, icon, description }, i) => (
              <Col
                key={i}
                xs={12}
                sm={6}
                md={6}
                lg={3}
                className="d-flex justify-content-center"
              >
                <div
                  className="step-card text-center p-4"
                  data-aos="fade-up"
                  data-aos-delay={150 + i * 150}
                >
                  <div className="icon-wrapper mb-3">{icon}</div>
                  <h5
                    className={`fw-bold title-clickable ${
                      activeIdx === i ? "active-title" : ""
                    }`}
                    onClick={() => handleTitleClick(i)}
                  >
                    {title}
                  </h5>
                  <p className="text-muted small">{description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
}
